import { discussions } from '@/mocks/comic';

export default function Community() {
  return (
    <section id="community" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              追更讨论社区
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">
              找到同好，一起把剧情聊透
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              每个人看故事的角度都不一样，而最好的解读往往来自不同观点的碰撞。在这里分享你的预测、质疑与发现，追更不孤单。
            </p>

            <div className="mt-7 grid grid-cols-3 gap-4">
              <div className="rounded-lg bg-background-100 p-4 text-center ring-1 ring-background-200/70">
                <p className="font-heading text-2xl font-black text-primary-600">12k+</p>
                <p className="mt-1 text-xs text-foreground-500">活跃同好</p>
              </div>
              <div className="rounded-lg bg-background-100 p-4 text-center ring-1 ring-background-200/70">
                <p className="font-heading text-2xl font-black text-secondary-600">1.8w</p>
                <p className="mt-1 text-xs text-foreground-500">累计讨论</p>
              </div>
              <div className="rounded-lg bg-background-100 p-4 text-center ring-1 ring-background-200/70">
                <p className="font-heading text-2xl font-black text-accent-600">98%</p>
                <p className="mt-1 text-xs text-foreground-500">讨论参与度</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-5 lg:col-span-3">
            {discussions.map((d) => (
              <article
                key={d.id}
                className="rounded-lg bg-background-100 p-5 ring-1 ring-background-200/70 transition-colors hover:bg-background-100/80 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span
                    className="flex h-10 w-10 items-center justify-center rounded-full font-heading text-sm font-bold text-background-50"
                    style={{ backgroundColor: d.avatar }}
                  >
                    {d.user.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{d.user}</p>
                    <p className="text-xs text-foreground-500">{d.time}</p>
                  </div>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{d.content}</p>
                <div className="mt-4 flex items-center gap-5 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-thumb-up-line" />
                    {d.likes}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {d.replies} 回复
                  </span>
                  <span className="ml-auto rounded-full bg-accent-100 px-3 py-1 font-medium text-accent-900 whitespace-nowrap">
                    同好精选
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}